import get from '@invitato/helpers/dist/getLocale';

export default {
  seeLocation: get('Lihat Lokasi', 'See Location'),
  remindMe: get('Ingatkan Acara', 'Remind Me'),
  back: get('Kembali', 'Back'),
  akad: get('AKAD', 'AKAD'),
  reception: get('RESEPSI PERNIKAHAN', 'WEDDING RECEPTION'),
  placeAndTime: get(`Waktu & <br /> Tempat`, `Place & <br /> Time`),
  placeAndTimeSub: get('WAKTU & TEMPAT', 'PLACE & TIME')
};
